var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtraordinaryConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1485,
    height: 1078,
    viewBox: "0 0 1485 1078",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M993.189 337.534L1033.31 376.606L1158.34 248.222L1118.22 209.149L993.189 337.534Z",
    fill: "#88D76C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.85 219.448L1252.73 274.996L1430.49 297.774L1437.6 242.226L1259.85 219.448Z",
    fill: "#C42231"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.62 229.837L1101.22 266.191L1217.54 129.873L1174.94 93.5195L1058.62 229.837Z",
    fill: "#FD4F7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.76 339.455L1183.91 357.094L1240.35 187.008L1187.19 169.369L1130.76 339.455Z",
    fill: "#E6A236"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.84 428.9L1477.8 375.855L1308.05 318.394L1290.09 371.44L1459.84 428.9Z",
    fill: "#FD864F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.09 355.733L1075.59 383.745L1165.22 228.568L1116.73 200.556L1027.09 355.733Z",
    fill: "#E65654"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 381.084L1174.03 419.365L1296.53 288.562L1255.65 250.281L1133.16 381.084Z",
    fill: "#FD4F7B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M755.248 755.925L810.998 750.612L793.988 572.212L738.238 577.526L755.248 755.925Z",
    fill: "#02B07D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M990.85 546.841L949.993 585.141L1072.56 715.886L1113.42 677.586L990.85 546.841Z",
    fill: "#E65654"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.25 431.234L1125.03 448.677L1180.86 618.97L1234.08 601.526L1178.25 431.234Z",
    fill: "#C42231"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.5 243.225L1239.98 267.482L1317.6 105.958L1267.12 81.7009L1189.5 243.225Z",
    fill: "#A46FE0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M755.389 607.369L798.513 643.1L912.849 505.111L869.725 469.379L755.389 607.369Z",
    fill: "#2A5B36"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.97 436.042L1225.84 489.751L1397.71 438.998L1381.84 385.289L1209.97 436.042Z",
    fill: "#F4FF7A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.92 333.487L1001.74 297.82L887.616 435.982L930.794 471.649L1044.92 333.487Z",
    fill: "#E65654"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.7 306.729L1102.78 263.08L963.101 150.804L928.016 194.452L1067.7 306.729Z",
    fill: "#FD864F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.91 463.907L1009.15 409.153L833.936 446.778L845.697 501.532L1020.91 463.907Z",
    fill: "#F4FF7A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M870.449 542.43L818.842 564.177L888.44 729.321L940.047 707.575L870.449 542.43Z",
    fill: "#0279B0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.15 747.574L1331.86 699.839L1179.11 793.555L1208.4 841.29L1361.15 747.574Z",
    fill: "#C42231"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1372.56 87.6543L1321.48 110.598L1394.91 274.075L1445.99 251.131L1372.56 87.6543Z",
    fill: "#A46FE0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.69 986.432L1415.36 931.66L1240.09 894.301L1228.42 949.073L1403.69 986.432Z",
    fill: "#88D76C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1420.61 1001.97L1412.2 946.606L1235.02 973.529L1243.44 1028.9L1420.61 1001.97Z",
    fill: "#0279B0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M915.447 325.796L873.761 363.191L993.432 496.593L1035.12 459.198L915.447 325.796Z",
    fill: "#88D76C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.78 654.41L1049.01 649.382L1032.93 827.866L1088.7 832.893L1104.78 654.41Z",
    fill: "#C42231"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M972.066 281.814L967.988 337.668L1146.72 350.727L1150.8 294.874L972.066 281.814Z",
    fill: "#0279B0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.97 533.343L1342.36 549.512L1394.1 721.088L1447.72 704.92L1395.97 533.343Z",
    fill: "#02B07D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M884.756 638.934L854.691 591.684L703.495 687.883L733.56 735.132L884.756 638.934Z",
    fill: "#E6A236"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.73 894.168L1371.86 845.745L1216.91 755.716L1188.77 804.139L1343.73 894.168Z",
    fill: "#88D76C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.32 398.34L1189.88 428.106L1285.14 579.904L1332.58 550.138L1237.32 398.34Z",
    fill: "#D5A4C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.8 702.09L1287.25 721.435L1349.16 889.611L1401.71 870.267L1339.8 702.09Z",
    fill: "#C42231"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1455.3 360.332L1418.52 318.097L1283.37 435.778L1320.15 478.014L1455.3 360.332Z",
    fill: "#FD4F7B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.2 620.874L1054.72 571.526L896.807 656.247L923.286 705.596L1081.2 620.874Z",
    fill: "#2A5B36"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M856.014 849.041L852.719 904.946L1031.62 915.499L1034.91 859.594L856.014 849.041Z",
    fill: "#E65654"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M973.633 500.988L1023.77 525.941L1103.61 365.506L1053.47 340.553L973.633 500.988Z",
    fill: "#D5A4C9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M413.627 888.367L409.903 944.245L588.715 956.171L592.44 900.293L413.627 888.367Z",
    fill: "#A46FE0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.68 826.11L1072.98 859.051L1178.38 714.125L1133.09 681.183L1027.68 826.11Z",
    fill: "#FD864F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M764.365 698.479L745.424 645.776L576.776 706.378L595.717 759.081L764.365 698.479Z",
    fill: "#E6A236"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M807.629 445.012L761.628 413.069L659.416 560.265L705.417 592.208L807.629 445.012Z",
    fill: "#C42231"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M623.689 699.101L569.746 714.147L617.902 886.766L671.845 871.72L623.689 699.101Z",
    fill: "#FD864F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.48 359.929L1120.56 401.137L1252.43 522.49L1290.35 481.282L1158.48 359.929Z",
    fill: "#D5A4C9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M638.912 828.793L694.467 821.727L671.847 643.952L616.292 651.018L638.912 828.793Z",
    fill: "#02B07D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M712.15 562.073L695.992 615.693L867.579 667.409L883.738 613.789L712.15 562.073Z",
    fill: "#F4FF7A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.74 781.456L1079.98 747.788L972.251 890.993L1017 924.661L1124.74 781.456Z",
    fill: "#88D76C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.45 629.457L1157.46 630.428L1160.57 809.608L1216.57 808.637L1213.45 629.457Z",
    fill: "#2A5B36"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M801.107 875.347L790.054 820.445L614.37 855.806L625.423 910.707L801.107 875.347Z",
    fill: "#A46FE0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M838.933 536.566L789.757 509.769L704.014 667.129L753.191 693.926L838.933 536.566Z",
    fill: "#88D76C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M945.771 1055.29L941.281 999.467L762.648 1013.83L767.139 1069.65L945.771 1055.29Z",
    fill: "#C42231"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M363.723 879.899L313.594 854.928L233.692 1015.33L283.82 1040.3L363.723 879.899Z",
    fill: "#0279B0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M462.381 646.759L422.463 607.477L296.768 735.206L336.685 774.487L462.381 646.759Z",
    fill: "#E65654"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M940.039 530.088L901.495 570.714L1031.51 694.062L1070.05 653.436L940.039 530.088Z",
    fill: "#88D76C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M364.41 951.821L326.816 910.31L193.986 1030.6L231.58 1072.11L364.41 951.821Z",
    fill: "#FD4F7B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M454.879 741.145L400.929 756.167L449.011 928.807L502.96 913.785L454.879 741.145Z",
    fill: "#FD864F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M870.916 947.163L874.373 1003.06L1053.24 992.004L1049.78 936.108L870.916 947.163Z",
    fill: "#A46FE0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M469.598 852.652L424.768 886.215L532.179 1029.67L577.008 996.11L469.598 852.652Z",
    fill: "#02B07D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M804.184 902.987L762.115 866.018L643.82 1000.63L685.888 1037.6L804.184 902.987Z",
    fill: "#02B07D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraordinaryConfetti);
export default __webpack_public_path__ + "static/media/extraordinary-confetti.478e43cbe6b4d7d36ee4c38c1e1342be.svg";
export { ForwardRef as ReactComponent };